import Vue from 'vue'
import Router from 'vue-router'

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)

import Layout from '@/layout'

export const constantRouterMap = [
  {
    path: '/redirect',
    component: Layout,
    children: [{
      path: '/redirect/:path*',
      component: () => import('@/pages/redirect/index')
    }]
  },
  {
    path: '/login',
    component: () => import('@/pages/login/index'),
    children: [
      //   {
      //   path: 'forgetPassword',
      //   name:'forgetPassword',
      //   component: () => import('@/pages/login/passwordFrom')
      // }
    ]
  },
  {
    hidden: true,
    path: '/login/forgetPassword',
    component: () => import('@/pages/login/passwordFrom'),
    name: 'forgetPassword',
    
  },
  {
    path: '/404',
    component: () => import('@/pages/error-page/404'),
  },
  {
    path: '/mini-concern',
    component: () => import('@/pages/mini/concern'),
  },
  {
    path: '/',
    component: Layout,
    redirect: '/home',
    children: [{
      path: 'home',
      component: () => import('@/pages/home/index'),
      name: 'home',
      meta: {
        title: '我的工作台',
        icon: 'panel',
        noCache: true
      }
    }]
  },
]
let routes = constantRouterMap;
export const createRouter = (routes) => new Router({
  // mode: 'history', // require service support
  // scrollBehavior: () => ({ y: 0 }),
  routes
})

const router = createRouter(routes)
export default router